$(document).ready(function () {

    // Header collision
    setInterval(function () {

        if( !$('html').hasClass('activemenu') ) {
            //Logo
            $('.logo').removeClass('light');
            $('.bg--black').collision('.logo').addClass('light');
            //Menu
            $('.burger').removeClass('light');
            $('.bg--black').collision('.burger').addClass('light');
        } else {
            $('.logo').removeClass('light');
            $('.burger').removeClass('light');
        }

    }, 500);

}); //document ready